import { MOUNTING_RAIL, UPRIGHT } from "./index";
import { INSERT, LEFT } from "@inter-ikea-storagetwo/range/dist/constants";
import { ADJUSTABLE } from "@inter-ikea-storagetwo/range/dist/constants/connectorKeys";
export const MOUNTING_RAIL_TO_UPRIGHT = `${MOUNTING_RAIL}-to-${UPRIGHT}`;
export const UPRIGHT_TO_MOUNTING_RAIL = `${UPRIGHT}-to-${MOUNTING_RAIL}`;
export const MOUNTING_RAIL_TO_UPRIGHT_LEFT = `${MOUNTING_RAIL_TO_UPRIGHT}-${LEFT}`;
export const UPRIGHT_TO_MOUNTING_RAIL_LEFT = `${UPRIGHT_TO_MOUNTING_RAIL}-${LEFT}`;
export const UPRIGHT_TO_MOUNTING_RAIL_600 = `${UPRIGHT_TO_MOUNTING_RAIL}-x:600`;
export const UPRIGHT_TO_MOUNTING_RAIL_800 = `${UPRIGHT_TO_MOUNTING_RAIL}-x:800`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE = `${UPRIGHT_TO_MOUNTING_RAIL}-${ADJUSTABLE}`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_0 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-0`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_1 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-1`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_2 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-2`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_3 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-3`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_4 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-4`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_5 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-5`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_6 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-6`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_7 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-7`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_8 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-8`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_9 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-9`;
export const UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_10 = `${UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE}-10`;
export const MOUNTING_RAIL_TO_WALL = "attach-to-wall";
export const INSERT_TO_UPRIGHT = `${INSERT}-to-${UPRIGHT}`;
export const UPRIGHT_TO_INSERT = `${UPRIGHT}-to-${INSERT}`;
export const MOUNTING_RAIL_ADJUSTABLE_CONNECTORS = [
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_0,
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_1,
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_2,
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_3,
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_4,
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_5,
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_6,
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_7,
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_8,
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_9,
    UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_10,
];
export const MOUNTING_RAIL_RIGHT_SIDE_UPRIGHT_CONNECTORS = [
    UPRIGHT_TO_MOUNTING_RAIL_600,
    UPRIGHT_TO_MOUNTING_RAIL_800,
    ...MOUNTING_RAIL_ADJUSTABLE_CONNECTORS,
];
export const MOUNTING_RAIL_ART_NUMBERS = {
    [UPRIGHT_TO_MOUNTING_RAIL_600]: "70575594",
    [UPRIGHT_TO_MOUNTING_RAIL_800]: "20575596",
};
export const ALIGN_MOUNTING_RAIL_TO_UPRIGHT_RIGHT = "align-mounting-rail-to-upright-right";
export const ALIGN_MOUNTING_RAIL_TO_UPRIGHT_LEFT = "align-mounting-rail-to-upright-left";
export const ALIGN_UPRIGHT_TO_MOUNTING_RAIL = "align-upright-to-mounting-rail";
export const RIGHT_ATTACH_TO_CLOTH_RAIL_CONNECTOR = "right-attach-to-cloth-rail-connector";
export const SIZE_TO_HOST_CONNECTOR_MAP = {
    200: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_0,
    210: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_1,
    220: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_2,
    230: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_3,
    240: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_4,
    250: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_5,
    260: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_6,
    270: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_7,
    280: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_8,
    290: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_9,
    300: UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_10,
    600: UPRIGHT_TO_MOUNTING_RAIL_600,
    800: UPRIGHT_TO_MOUNTING_RAIL_800,
};
